import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/header';
import './tools/backToTop';
